const firebaseConfig = {
  apiKey: "AIzaSyCk8DyZmOHuKOtk4GLKPol2m4fFsnqjJf0",
  authDomain: "med-health-e3f2a.firebaseapp.com",
  projectId: "med-health-e3f2a",
  storageBucket: "med-health-e3f2a.appspot.com",
  messagingSenderId: "776935860055",
  appId: "1:776935860055:web:422a3550405bb210700012",
};

export default firebaseConfig;
